
define(
	'Tavanoteam.Videos.Videos'
	, [
		'Videos.View',
		'Videos.Model',
		'Videos.Collection'
	]
	, function (
		VideosView,
		VideosModel,
		VideosCollection
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var pageTypeComponent = container.getComponent('PageType');

				var model = new VideosModel(),
					collection = new VideosCollection(),
					options = {
						container: container,
						model: model,
						collection: collection
					};

				var view = {
					name: 'pagetype_videos_extension',
					view: VideosView,
					options: options,
					defaultTemplate: {
						name: 'videos.tpl',
						displayName: 'Sunshine Supply Videos'
					}
					, routes: ['videos']
				}

				pageTypeComponent.registerPageType(view);
			}
		};
	});
